/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { maxAvgCheckSchema } from "./maxAvgCheckSchema.ts";
import { periodStatsSchema } from "./periodStatsSchema.ts";
import { totalOrganizationStatsSchema } from "./totalOrganizationStatsSchema.ts";

export const totalStatsBlockSchema = z.object({
	order_count: z.int(),
	total_sum: z.number(),
	avg_check: z.number(),
	max_avg_check: maxAvgCheckSchema,
	organizations: z.array(totalOrganizationStatsSchema),
	periods: z.array(periodStatsSchema).optional(),
});
